// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76ec9013","453":"fca78908","732":"910532e4","977":"59a1572f"}[chunkId] + ".chunk.js";
};